import React, { useState } from 'react';
import './CalculatorPage.css';

function NameChangeSuggestionCalculator() {
  const [currentName, setCurrentName] = useState('');
  const [dob, setDob] = useState('');
  const [suggestion, setSuggestion] = useState(null);
  const [error, setError] = useState('');

  const calculateNameValue = (name) => {
    let sum = 0;
    const nameMap = {
      'A': 1, 'J': 1, 'S': 1,
      'B': 2, 'K': 2, 'T': 2,
      'C': 3, 'L': 3, 'U': 3,
      'D': 4, 'M': 4, 'V': 4,
      'E': 5, 'N': 5, 'W': 5,
      'F': 6, 'O': 6, 'X': 6,
      'G': 7, 'P': 7, 'Y': 7,
      'H': 8, 'Q': 8, 'Z': 8,
      'I': 9, 'R': 9
    };

    for (let i = 0; i < name.length; i++) {
      const char = name[i].toUpperCase();
      if (nameMap[char]) {
        sum += nameMap[char];
      }
    }
    return sum;
  };

  const calculateLifePath = (dateString) => {
    const digitsOnly = dateString.replace(/\D/g, '');
    if (digitsOnly.length !== 8) return null;

    let sum = 0;
    for (let i = 0; i < digitsOnly.length; i++) {
      sum += parseInt(digitsOnly[i], 10);
    }

    while (sum > 9 && sum !== 11 && sum !== 22 && sum !== 33) {
      sum = sum.toString().split('').reduce((s, d) => s + parseInt(d, 10), 0);
    }
    return sum;
  };

  const generateSuggestion = (currentNameValue, lifePathNumber) => {
    // Placeholder for Name Change Suggestion logic
    // This is a highly simplified example. Real suggestions would be complex.
    if (currentNameValue % 2 === 0 && lifePathNumber % 2 !== 0) {
      return "Consider a name with an odd numerological value to align with your life path.";
    } else if (currentNameValue % 3 === 0 && lifePathNumber % 5 === 0) {
      return "A name change might bring more adventure and freedom into your life.";
    } else {
      return "Your current name seems to align well with your numerological profile, or further analysis is needed.";
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setSuggestion(null);

    if (!currentName || !dob) {
      setError('Please enter both your current name and date of birth.');
      return;
    }

    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!dateRegex.test(dob)) {
      setError('Please enter a valid date in DD/MM/YYYY format.');
      return;
    }

    const nameValue = calculateNameValue(currentName);
    const lifePath = calculateLifePath(dob);

    if (lifePath === null) {
      setError('Invalid date of birth. Please check your input.');
      return;
    }

    setSuggestion(generateSuggestion(nameValue, lifePath));
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Name Change Suggestion Calculator",
    "description": "Get numerological suggestions for a name change based on your current name and birth date.",
    "url": "https://www.yourwebsite.com/name-change-suggestion-calculator",
    "potentialAction": {
      "@type": "CalculateAction",
      "name": "Get Name Change Suggestion",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.yourwebsite.com/name-change-suggestion-calculator?currentName={currentName}&dob={dob}",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "query-input": [
        "required name=currentName",
        "required name=dob"
      ]
    }
  };

  return (
    <div className="calculator-page container my-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <h1 className="text-center text-primary">Name Change Suggestion Calculator</h1>
      <p className="text-center">Get numerological insights for a potential name change.</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="currentName">Current Name:</label>
          <input
            type="text"
            id="currentName"
            className="form-control"
            value={currentName}
            onChange={(e) => setCurrentName(e.target.value)}
            placeholder="e.g., Jane Doe"
          />
        </div>
        <div className="form-group">
          <label htmlFor="dob">Date of Birth (DD/MM/YYYY):</label>
          <input
            type="text"
            id="dob"
            className="form-control"
            value={dob}
            onChange={(e) => setDob(e.target.value)}
            placeholder="e.g., 01/01/1990"
            maxLength="10"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Get Suggestion</button>
      </form>

      {suggestion !== null && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Suggestion:</h2>
          <p className="result-explanation">{suggestion}</p>
        </div>
      )}
    </div>
  );
}

export default NameChangeSuggestionCalculator;
